const ModalItensOrcamentoController = ObjectBase.extend({

    show: function () {

        if (!this.modal) {
            return;
        }

        this.$modal = $(this.modal);

        if (!this.$modal || this.$modal.lengt == 0) {
            return;
        }

        this.listar();
    },

    listar: function() {

        var self = this;

        global.ajax({
            url: '/Orcamento/ListarItensOrcamento',
            type: 'post',
            data: {
                identificadorOrcamento: this.orcamento.get('IdentificadorOrcamento')
            },
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                data.Itens = _.sortBy(data.Itens, function (e) { return e.OrdemItem; });

                self.model = ko.mapping.fromJS(data);
                $('table', self.$modal).removeAttr('instantiated');
                self.controller.applyBindings(self, self.$modal[0]);
                self.$modal.on('shown.bs.modal',
                    function() {
                        $('#modalListarItens-container').scrollLeft(0);
                    });
                self.$modal.modal();
            }
        });

    }


})

window.ModalItensOrcamentoController = ModalItensOrcamentoController

export {ModalItensOrcamentoController}